import * as Sentry from '@sentry/browser';

const trackException = ({ error, exception }) => Sentry.captureException(error || exception);

export default { trackException };
